import React from "react";
import { useFilter } from "../../FilterContext";
import { FREQUENCY_OPTIONS, uniqueCustomers } from "./recurringInvoiceUtils";

const SORT_FIELDS = [
  { value: "next_run", label: "Next run date" },
  { value: "amount", label: "Amount" },
  { value: "customer", label: "Customer" },
  { value: "name", label: "Schedule name" },
];

export default function RecurringFilterDrawer({
  templates = [],
  customerFilter,
  setCustomerFilter,
  frequencyFilter,
  setFrequencyFilter,
  sortField,
  setSortField,
}) {
  const {
    showDrawer,
    setShowDrawer,
    entriesPerPage,
    setEntriesPerPage,
    sortOrder,
    setSortOrder,
    customDate,
    setCustomDate,
  } = useFilter();

  const customers = uniqueCustomers(templates);

  const handleReset = () => {
    setEntriesPerPage(10);
    setSortOrder("asc");
    setCustomDate({ from: "", to: "" });
    setCustomerFilter("");
    setFrequencyFilter("");
    setSortField("next_run");
  };

  if (!showDrawer) return null;

  return (
    <div className="premium-filter-drawer">
      <div className="premium-drawer-header">
        <h2>Auto-billing filters</h2>
        <button type="button" className="premium-close-btn" onClick={() => setShowDrawer(false)}>
          ×
        </button>
      </div>

      <div className="premium-drawer-body">
        <div className="premium-filter-group">
          <label>Customer</label>
          <select value={customerFilter} onChange={(e) => setCustomerFilter(e.target.value)}>
            <option value="">All customers</option>
            {customers.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>

        <div className="premium-filter-group">
          <label>Frequency</label>
          <select value={frequencyFilter} onChange={(e) => setFrequencyFilter(e.target.value)}>
            {FREQUENCY_OPTIONS.map((opt) => (
              <option key={opt.value || "all"} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="premium-filter-group">
          <label>Next run date range</label>
          <div className="premium-date-range">
            <input
              type="date"
              value={customDate.from}
              onChange={(e) => setCustomDate({ ...customDate, from: e.target.value })}
            />
            <input
              type="date"
              value={customDate.to}
              onChange={(e) => setCustomDate({ ...customDate, to: e.target.value })}
            />
          </div>
        </div>

        <div className="premium-filter-group">
          <label>Sort by</label>
          <select value={sortField} onChange={(e) => setSortField(e.target.value)}>
            {SORT_FIELDS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="premium-filter-group">
          <label>Sort order</label>
          <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
          </select>
        </div>

        <div className="premium-filter-group">
          <label>Entries per page</label>
          <select value={entriesPerPage} onChange={(e) => setEntriesPerPage(Number(e.target.value))}>
            {[10, 20, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="premium-drawer-footer">
        <button type="button" className="premium-reset-btn" onClick={handleReset}>
          Reset
        </button>
        <button type="button" className="premium-apply-btn" onClick={() => setShowDrawer(false)}>
          Apply
        </button>
      </div>
    </div>
  );
}
